export default __webpack_public_path__ + "static/banner-saving-for-a-baby-4db5ed254c3a16176530964cb09b27b2.jpg";